import React from 'react'
import "../styles/Loader.scss"
const Loader = (parent) => {
  return (
    <>

    {
        parent ? 
    <div class="loader_parent">
          <div class="loader"></div>
      </div>
      :
      <div class="loader"></div>
    }
   
  
      
    </>
  )
}

export default Loader
